module.exports = __webpack_public_path__ + "s/img/Chill_M_1.22d3b5da.jpg";